<template>
  <div
    class="
      absolute top-full flex max-h-[calc(100vh-var(--navbar-height)-5rem)] w-fit min-w-[25rem] max-w-full
      flex-col gap-2 overflow-y-auto p-10 text-white
    "
  >
    <div class="flex justify-between gap-40 hide-scrollbar">
      <!-- NAVIGATION -->
      <ul class="gap-10 space-y-3 py-5 typo-body-2xl slide-up" :class="{ 'columns-2': children.length > 7, 'xl:columns-3': children.length > 14 }">
        <li v-for="item in children" :key="item.page.id" class="">
          <NuxtLink
            :to="item.page.url"
            :target="useIsExternalUrl(item.page.url) ? '_blank' : '_self'"
            class="group flex size-fit items-center transition-colors"
            @focus="emit('has-focus-within', true)"
            @blur="emit('has-focus-within', false)"
            @keydown.space.prevent="emit('has-focus-within', false)"
          >
            <span>{{ item.page.title }}</span>
            <IconArrowDown
              class="
                w-[1.25em] -rotate-90 opacity-0 transition-[opacity,transform] ease-in-out
                group-hover:translate-x-3 group-hover:opacity-100
              "
            />
          </NuxtLink>
        </li>
      </ul>

      <!-- LINK CARD -->
      <div v-if="parent?.link" class="group relative flex h-fit flex-col slide-right">
        <!-- Image -->
        <div
          class="mb-5 aspect-[290/195] w-64 overflow-hidden rounded-br-[3.125rem] bg-white/10"
          :class="{ 'py-9 pl-18 pr-22': !parent.icon?.is_image }"
        >
          <AppImage
            v-if="parent.icon"
            :src="parent.icon"
            :alt="useMapAltText(parent.icon)"
            :class="parent.icon?.is_image ? 'object-cover' : 'object-contain' "
            :style="`object-position: ${parent.icon.focus_css};`"
            class="
              size-full text-white transition-transform ease-in-out will-change-transform
              group-hover:scale-110
            "
          />
        </div>

        <!-- Heading -->
        <h3 class="mb-10 typo-body-3xl">
          {{ parent.heading }}
        </h3>

        <!-- Link -->
        <div class="">
          <AppLink
            use-simple-arrow
            :to="parent.link"
            class="mb-3 mt-auto typo-body-xl after:absolute after:inset-0"
            @focus="emit('has-focus-within', true)"
            @blur="emit('has-focus-within', false)"
            @keydown.space.prevent="emit('has-focus-within', false)"
          >
            {{ parent.link_text }}
          </AppLink>
        </div>

        <div class="w-full border-b-2" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { NavigationAndGlobalsQuery } from '~/queries/generated/NavigationAndGlobals'

type NavItem = NonNullable<NavigationAndGlobalsQuery['main']>['tree'][number]['page']
defineProps<{
  children: NavItem[]
  parent: NavItem
}>()

const emit = defineEmits(['has-focus-within'])
</script>
